import React from 'react';
import TopBar from '../../../Components/TopBar';
import Page from '../../../Components/Containers/Page';
import { useTemplates } from '../../../Data/Templates';
import { getEntityLink } from '../../../Services/helpers';
import { Link } from 'react-router-dom';
import { PageLoading } from '../../../Components/Loading';
import Icon from '../../../Components/Icons/Icon';
import Tabs, {Tab} from '../../../Components/Containers/Tabs/Tabs';

const MessageTemplates = () => {
    const {templates} = useTemplates(true);

    return <>
        <TopBar left="BackBtn" title="Message Templates" />

        <Page>
            {templates ? <Inner templates={templates} /> : <PageLoading />}
        </Page>
    </>
}

const Inner = ({templates}) => {
    if (templates.length === 0) {
        return <p className="text-muted text-center">
            You have no message templates.<br />
            This shouldn't happen, please contact support.
        </p>
    }

    return <Tabs>
        <Tab title="Customers">
            <Templates templates={templates.filter(template => template.category === 'Customers')} />
        </Tab>
        <Tab title="Quotes">
        <Templates templates={templates.filter(template => template.category === 'Quotes')} />
        </Tab>
    </Tabs>
}

const Templates = ({templates}) => {
    return <ul className="divide-y divide-gray-200 mb-5">
        {templates && templates.map(template => {
            return <li key={template.id}>
            <Link to={getEntityLink('Templates/Template', template.id)} className="w-full py-3 flex">
                <div className="grow">
                    <p>{template.title}</p>
                </div>
                <div className="flex flex-none items-center gap-x-4 shrink-0">
                    <Icon icon="RightChevron" className="mr-2" size="2x" inline />
                </div>
            </Link>
        </li>
        })}
    </ul>
}

export default MessageTemplates;
